import { ButtonProps } from '@material-ui/core';
import ImportedStyledActionButtons from 'common/styled/StyledActionButton/StyledActionButton';
import styled from 'styled-components';

const StyledActionButtonImpl = styled(ImportedStyledActionButtons)`
    margin-top: 6px;
`;

export const StyledActionButton = (props: Pick<ButtonProps, 'children' | 'onClick'>) => {
    return (
        <StyledActionButtonImpl color='primary' variant='outlined' {...props} />
    );
};